import Patterns from '../patterns.js';

export default [
  {
    name: 'path',
    label: {
      cs: 'Cesta',
      en: 'Path',
    },
    type: 'string',
    pattern: Patterns.ALPHANUMERIC,
    patternErrorMessage: Patterns.ALPHANUMERIC_MESSAGE,
    minLength: 2,
    maxLength: 128,
    required: true,
  },
];
